module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a69226a716d526754403451bee941325.png";